import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';

const HEIGHT = '36vh';
const MIN_HEIGHT = '447px';
const DESKTOP_HEIGHT = '50vw';
const MIN_DESKTOP_HEIGHT = '425px';

export const SectionWrapper = styled(Flex)<{ background: string; backgroundMobile: string }>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: bottom;
  height: ${HEIGHT};
  min-height: ${MIN_HEIGHT};
  background-image: ${props => `url(${props.backgroundMobile})`}, linear-gradient(0deg, ${themeColor('black')} 50%, transparent);
  ${themeMediaQuery('sm')} {
    position: relative;
    overflow: hidden;
    height: ${DESKTOP_HEIGHT};
    min-height: ${MIN_DESKTOP_HEIGHT};
    background-image: ${props => `url(${props.background})`};
  }
`;

export const StyledColumns = styled(Columns)`
  padding: 0 ${themeSpace(1)};
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-body {
    padding-top: ${themeSpace(5)};

    ${themeMediaQuery('below_sm')} {
      padding: 0 ${themeSpace(6)};
    }
  }
`;

export const StyledList = styled.ul`
  display: flex;
  justify-content: space-evenly;
  background-color: ${themeColor('yellow1')};
  padding: ${themeSpace(7)} ${themeSpace(2)} ${themeSpace(2)} ${themeSpace(2)};
`;

export const StyledListItem = styled.li`
  justify-content: center;
  display: flex;
  align-items: center;
`;

export const StyledCloudImage = styled(CloudImage)`
  border-radius: ${themeSpace(3)};
`;
